import React, {createContext, useContext} from 'react';
import {getCalculationData} from '../utils';
import {useTransfersByAgentContext} from './TransfersByAgentContext';

const TransferCalculationContext = createContext({});
export const useTransferCalculationContext = () => useContext(TransferCalculationContext);

export const TransferCalculationContextProvider = ({children}) => {
  const {history} = useTransfersByAgentContext();

  const calculate = (values, newPaycheck, paycheckYear, paycheckMonth) => {
    const monthCalc = history?.byMonth[`${paycheckYear}-${paycheckMonth}`] || {};
    return getCalculationData(values, newPaycheck, monthCalc);
  };

  return (
    <TransferCalculationContext.Provider value={{calculate}}>
      {children}
    </TransferCalculationContext.Provider>
  );
};